import React, { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const UserType = lazy(() => import('@pages/dashboard/UserType/index'));

const UserTypeRoutes: RouteObject[] = [
  {
    path: '/user-type',
    element: (
      <React.Suspense>
        <UserType />
      </React.Suspense>
    ),
    children: [],
  },
];

export default UserTypeRoutes;